function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".appUnsynced_svg__a{fill:#ffba51}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "appUnsynced_svg__a",
  d: "M19.511 16.559a.813.813 0 00-.552.03.672.672 0 00-.367.367 2.865 2.865 0 01-2.207 1.716 3.206 3.206 0 01-2.796-.812.146.146 0 01.006-.22l1.245-1.096a.292.292 0 00.078-.347.365.365 0 00-.334-.197h-3.222a.388.388 0 00-.256.093.3.3 0 00-.106.226v2.84a.32.32 0 00.223.294.398.398 0 00.395-.069l.7-.618a.2.2 0 01.26.004 4.784 4.784 0 004.142 1.143 4.256 4.256 0 003.24-2.545.622.622 0 00-.449-.81z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 0h-15A2.506 2.506 0 000 2.512v12.976A2.506 2.506 0 002.5 18h5.417a.837.837 0 000-1.674H2.5a.835.835 0 01-.833-.838V4.396a.209.209 0 01.207-.21h16.251a.209.209 0 01.208.21V8.79a.833.833 0 101.667 0V2.51A2.506 2.506 0 0017.5 0z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "appUnsynced_svg__a",
  d: "M19.777 11.5a.391.391 0 00-.392.07l-.74.662a.19.19 0 01-.129.048.193.193 0 01-.128-.05 4.725 4.725 0 00-4.127-1.14 4.265 4.265 0 00-3.222 2.578.633.633 0 00.449.82.757.757 0 00.873-.314l.042-.088a2.862 2.862 0 012.188-1.74 3.161 3.161 0 012.783.807.15.15 0 01-.004.224l-1.196 1.072a.3.3 0 00-.078.351.363.363 0 00.332.2h3.212a.343.343 0 00.36-.323v-2.88a.325.325 0 00-.223-.298z"
});

function SvgAppUnsynced(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "appUnsynced.6a55f.svg";
export { SvgAppUnsynced as ReactComponent };